import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import commonActions from "../actions";
import _ from "lodash";
import Draggable from "react-draggable";

const Lines = ({ element, index, isSmartChart = false }) => {
    const bgClass = index % 2 !== 0 ? "blue-bg" : "grey-bg";
    return (
        <div className={`${bgClass} content-preview not-draggable ${isSmartChart ? "smart-chart-line" : ""}`}>
            {element?.map((item, i) => (
                <>
                    {item}
                    {!isSmartChart ? <br /> : <>&nbsp;</>}
                </>
            ))}
        </div>
    );
};
class PreviewModal extends Component {
    render() {
        const previewData = this.props.previewData();
        const { isSmartChart = false } = this.props;

        return (
            <React.Fragment>
                <div
                    className="modal modal-region modal-view reco-view-mdl manage-preview-modl"
                    id="modalId"
                    style={{ display: "block" }}
                    tabIndex="-1"
                >
                    <Draggable cancel=".not-dragabble">
                        <div className="modal-dialog draggable" role="document">
                            <div className="modal-content">
                                <div className={`modal-header ${isSmartChart ? "smart-chart-header" : ""}`}>
                                    <h4>{isSmartChart ? "Page Header Config Preview" : "Heading Preview"}</h4>
                                    <button type="button" className="close" onClick={this.props.onCancel}>
                                        <span aria-hidden="true">
                                            <img src="/img/close.svg" alt="" />
                                        </span>
                                    </button>
                                </div>
                                <div className={`modal-body region-otr ${isSmartChart ? "smart-chart-body" : ""}`}>
                                    {previewData.map((elem, idx) => (
                                        <Lines element={elem} index={idx} isSmartChart={isSmartChart} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Draggable>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const { commonReducer } = state;
    return { commonReducer };
};

export default withRouter(connect(mapStateToProps, { ...commonActions })(PreviewModal));
